import React from 'react';
export function HeroSection() {
  return <>
      <div className="max-w-[800px] mx-auto px-7 pt-16 pb-10" data-id="element-63">
        <p className="font-sans text-[0.72rem] font-bold tracking-[0.15em] uppercase text-amber mb-[18px]" data-id="element-64">
          Erfahrungsbericht · Juckreiz beim Hund
        </p>
        <h1 className="font-serif text-[clamp(1.85rem,4.5vw,2.75rem)] font-bold leading-[1.22] text-text mb-[26px]" data-id="element-65">
          Mein Hund kratzte sich jahrelang wund – bis ich endlich den wahren
          Auslöser gefunden habe
        </h1>
        <p className="text-[1.1rem] italic text-text-mid leading-[1.8] border-l-[3px] border-amber pl-5 mb-8" data-id="element-66">
          Drei Jahre Juckreiz, unzählige Tierarztbesuche, Spezialshampoos und
          Eliminationsdiäten. Nichts hat dauerhaft geholfen – weil ich immer an
          der Haut angesetzt habe. Dabei lag das Problem ganz woanders: in
          Lenies Darm.
        </p>
        <div className="flex items-center gap-3 font-sans text-[0.83rem] text-text-muted" data-id="element-67">
          <div className="w-[38px] h-[38px] rounded-full bg-amber-lt flex items-center justify-center text-[1.1rem] flex-shrink-0" data-id="element-68">
            🐾
          </div>
          <div data-id="element-69">
            <strong className="text-text-mid font-semibold" data-id="element-70">Sarah M.</strong>,
            Hundemama aus Hamburg
            <br data-id="element-71" />
            Leni, 5 Jahre, Labrador-Mix &nbsp;·&nbsp; April 2025
          </div>
        </div>
      </div>
      <hr className="max-w-[800px] mx-auto mt-8 mb-0 border-0 border-t border-border" data-id="element-72" />
    </>;
}